import { TableSorting } from '@src/types'
import { AxiosRequestConfig } from 'axios'
import { ApiRes, api } from './client'

export interface Audit {
    id: string
    auditable_type: string
    auditable_id: string
    user_id: string
    event: 'created' | 'updated' | 'deleted' | 'restored'
    user_agent: string
    ip_address: string
    old_values?: Record<string, unknown>
    new_values?: Record<string, unknown>
    created_at: string
    updated_at: string
}

export type AuditsResponse = {
    success: boolean
    audits: Audit[]
    audits_count: number
}

export const getAudits = (
    filters?: Record<string, unknown>,
    page?: number,
    limit?: number,
    sorting?: TableSorting[]
): ApiRes<AuditsResponse> => {
    const config: AxiosRequestConfig = {}

    config.params = {}

    if (filters && Object.keys(filters).length) {
        config.params = filters
    }

    if (typeof page === 'number' && typeof limit === 'number') {
        config.params['range'] = page * limit - limit + '-' + page * limit
    }

    if (sorting && sorting.length) {
        config.params['sort'] = sorting
            .map((sort) => {
                return (sort.direction === 'desc' ? '-' : '') + sort.field
            })
            .join(',')
    }
    return api.get('/v2/manage/audits', config)
}
